import { PANEL_WIDTH as COPILOT_PANEL_WIDTH } from 'components/App/DesktopView/Layout/HelplyCopilotPanel/styles'

// The docked copilot drawer is a fixed overlay covering the rightmost
// COPILOT_PANEL_WIDTH px of the window. While it's open, force the right
// sidebar pane (always the last pane) to exactly that width so the drawer
// covers only the sidebar and the center editor reflows clear of it. The pane
// is locked (min = size = max) so dragging can't persist the forced width —
// the stored widths are untouched and reapply when the copilot closes.
// Returns the input array unchanged (same reference) when no forcing is
// needed, so callers can detect via identity whether the width is forced.
export function applyCopilotPanelWidth(panelWidths) {
  if (!Array.isArray(panelWidths) || !panelWidths.length) return panelWidths
  const lastIndex = panelWidths.length - 1
  const sidebar = panelWidths[lastIndex]
  if (!sidebar || typeof sidebar !== 'object') return panelWidths
  // Already at least as wide as the drawer — it can't reach the editor, so
  // leave the agent's width (and resizability) alone. A missing/non-numeric
  // size fails this check and falls through to forcing, which is safe.
  if (sidebar.size >= COPILOT_PANEL_WIDTH) return panelWidths
  return panelWidths.map(
    (panel, index) =>
      index === lastIndex
        ? {
            ...panel,
            size: COPILOT_PANEL_WIDTH,
            minSize: COPILOT_PANEL_WIDTH,
            maxSize: COPILOT_PANEL_WIDTH,
          }
        : panel
  )
}

// Companion for PanelGroup's onUpdate: a drag on any divider while the copilot
// is open reports the forced sidebar entry back. Swap the stored sidebar entry
// back in before persisting so the forced width never reaches storage and the
// sidebar returns to its saved size when the copilot closes.
export function keepStoredSidebarWidth(updatedWidths, storedWidths) {
  if (!Array.isArray(updatedWidths) || !updatedWidths.length) {
    return updatedWidths
  }
  const stored = Array.isArray(storedWidths) ? storedWidths : []
  const lastIndex = updatedWidths.length - 1
  return updatedWidths.map(
    (panel, index) =>
      index === lastIndex && stored[index] ? stored[index] : panel
  )
}
